import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getFormResponse(formId, status, triggerId, offset) {
  const params = {
    formId: formId,
    offset: offset * 20,
    max: 20,
  };
  if (status) {
    params.status = status;
  }
  if (triggerId) {
    params.triggerId = triggerId;
  }

  return ApiService({
    method: "GET",
    url: `${apiBasePath}/formResponse`, 
    params: params,
  });
}

export function getFormResponseForResponder({ formId, triggerId, status, offset }) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/formResponse/myResponses`,
    params: {
      formId,
      triggerId,
      status,
      offset: offset * 20,
      max: 20,
      asResponder: true,
    },
  });
}

export function getFormResponseForAttendee ({ formId, offset }) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/formResponse/myResponses`,
    params: {
      formId,
      offset: offset * 20,
      max: 20,
      asAttendee: true,
    },
  });
}


export function getResponseListingFilterOptions() {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/filtersForResponseListing`,
  });
}

export function getResponseListingFilterOptionsForAttendee() {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/filtersForResponseListing`,
    params: {
      asAttendee: true,
    },
  });
}

export function updateFormResponse(formDetails) {
  return ApiService({
    method: "PATCH",
    url: `${apiBasePath}/formResponse`,
    data: formDetails,
  })
}

export function getNonAttendeesAndProjects({ formId }) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/nonAttendeesAndProjects/${formId}`,
  });
}

export function getFormResponseForMentor({ formId, offset }) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/formResponse/myResponses`,
    params: {
      formId,
      offset: offset * 20,
      max: 20,
      asMentor: true, 
    },
  });
}

export function getResponseListingFilterOptionsForMentor() {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/filtersForResponseListing`,
    params: {
      asMentor: true,
    },
  });
}

